import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { addCommas } from '../../../utils/utils';
import { hasKLFollowCallBeenEnabled } from '../../../utils/userUtils';
import { DateRangesV2 } from '../../../constants/ComponentTypes';
import moment from 'moment';
import { connect } from 'react-redux';
import { OwnerType } from '../../../constants/ComponentTypes';
import PanelHeader from '../parts/PanelHeader';
import TermRangeDialog from '../../common/TermRangeDialog';
import * as actions from '../../../redux/actions/OrderDashboard';

const styles = () => ({
  root: {
    transform: 'translateY(20px)',
    width: '100%',
    padding: '0 25px',
    boxSizing: 'border-box',
  },

  flexContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%',
  },

  half: {
    width: 'calc(50% - 15px)',
    marginBottom: '23px',
  },

  left: {
    flexDirection: 'column',
  },

  right: {
    flexWrap: 'wrap',
  },

  panel: {
    width: '100%',
    padding: '22px 25px 32px 25px',
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px #0000001F',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginBottom: '24px',
  },

  col: {
    minWidth: '25%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  title: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '18px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  heading: {
    fontSize: '32px',
    color: '#181819',
    paddingBottom: '14px',
  },

  subheading: {
    fontSize: '12px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '16px',
  },

  note: {
    fontSize: '11px',
    color: '#71737B',
    marginTop: '-14px',
  },

  dropdown: {
    minWidth: '180px',
    margin: '12px 0 12px 12px',
  },

  iconButton: {
    color: '#71737B',
    padding: 0,
    width: '32px',
    minWidth: '32px',
    height: '32px',
    minHeight: '32px',
    marginLeft: '10px',
  },

  link: {
    fontSize: 11,
    color: "#1A65FF",
    textDecoration: 'none',
    textAlign: 'center',
    "&:hover": {
      textDecoration: 'underline',
    },
  },

  innerFlexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    width: '100%',
  },

  innerCol: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

class AchievementPanel extends React.Component {
  state = {
    dateSelected: DateRangesV2.PAST_1_YEAR,
    filterValue: {
      created_at_from: DateRangesV2.PAST_1_YEAR.from,
      created_at_to: DateRangesV2.PAST_1_YEAR.to,
    },
    showTermRangeDialog: false,
  }

  componentDidMount() {
    let query = this.filterValueToQuery();
    !this.props.isDemo && this.props.getOrderAchievement({
      ...query,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      this.setState({
        dateSelected: DateRangesV2.PAST_1_YEAR,
        filterValue: { ...this.state.filterValue, ...{ 'created_at_from': DateRangesV2.PAST_1_YEAR.from, 'created_at_to': DateRangesV2.PAST_1_YEAR.to } },
      }, () => {
        let query = this.filterValueToQuery();
        !this.props.isDemo && this.props.getOrderAchievement({
          ...query,
        });
      });
    }
  }

  filterValueToQuery = (filterValue = this.state.filterValue, ownerType = this.props.ownerType) => {
    let data = {};
    for (let property in filterValue) {
      if (property === 'created_at_from' || property === 'created_at_to') {
        data[property] = filterValue[property] ? filterValue[property].format('YYYY-MM-DD') : null;
      } else {
        data[property] = filterValue[property];
      }
    }

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  toggleTermRangeDialog = (date) => {
    this.setState({
      // 表示制御
      showTermRangeDialog: !this.state.showTermRangeDialog
    }, () => {
      // クローズした場合で、決定ボタンにより期間が指定されていたら、選択肢と検索条件のstateを更新してAPIを叩く
      if (!this.state.showTermRangeDialog && date && date.startDate && date.endDate) {
        this.setState({
          dateSelected: DateRangesV2.USER_SPECIFIED,
          filterValue: { ...this.state.filterValue, ...{ 'created_at_from': moment(date.startDate), 'created_at_to': moment(date.endDate) } },
        }, () => {
          let query = this.filterValueToQuery();
          this.props.getOrderAchievement({
            ...query,
          });
        });
      }
    })
  }

  handleSelectDate = (item) => {
    // ユーザー指定の場合は期間していのダイアログを表示
    if (item.value === DateRangesV2.USER_SPECIFIED.value) {
      this.toggleTermRangeDialog();
    } else {
      let filterValue = {
        created_at_from: item.from ? item.from : null,
        created_at_to: item.to ? item.to : null,
      };
      this.setState({
        dateSelected: item,
        filterValue: { ...this.state.filterValue, ...filterValue },
      }, () => {
        let query = this.filterValueToQuery();
        this.props.getOrderAchievement({
          ...query,
        });
      });
    }
  }

  renderTermRangeDialog = () => {
    if (this.state.showTermRangeDialog) {
      // 選択値が期間指定ありかつ、ユーザー指定の場合は、その値を渡すが、他の選択肢の場合は初期値を渡す
      const startDate = (this.state.dateSelected === DateRangesV2.USER_SPECIFIED && this.state.filterValue.created_at_from) ? this.state.filterValue.created_at_from : DateRangesV2.USER_SPECIFIED.from;
      const endDate = (this.state.dateSelected === DateRangesV2.USER_SPECIFIED && this.state.filterValue.created_at_to) ? this.state.filterValue.created_at_to : DateRangesV2.USER_SPECIFIED.to;

      return (
        <TermRangeDialog
          isOpen={this.state.showTermRangeDialog}
          toggleDialog={this.toggleTermRangeDialog}
          startDate={startDate.toDate()}
          endDate={endDate.toDate()}
        />
      )
    }
  }

  renderItem = (item, i, isLast) => {
    const { classes } = this.props;

    return (
      <div className={classes.col} key={i} style={{ borderRight: isLast ? "" : '1px solid #E7E9EB', width: '50%' }} >
        <Typography className={classes.subheading}>{item.title}</Typography>
        <Typography className={classes.heading}>
          {item.targetCount}{item.unit}
        </Typography>
        {item.targetCompanyCount && (
          <Typography className={classes.note}>
            企業数: {item.targetCompanyCount}社
          </Typography>
        )}
      </div>
    )
  }

  render() {
    const { classes, achievement, isLoading, isDemo } = this.props;

    let menu = [
      {
        "title": "アプローチ人数",
        "unit": "人",
        "targetCount": isDemo ? AchievementPanel.ACHIEVEMENT_DEMO_DATA["APPROACH_ADDRESS_COUNT"] : (isLoading ? '- ' : addCommas(achievement.approach_address_count)),
        "targetCompanyCount": isDemo ? AchievementPanel.ACHIEVEMENT_DEMO_DATA["APPROACH_COMPANY_COUNT"] : (isLoading ? '- ' : addCommas(achievement.approach_company_count)),
      },
      {
        "title": "送付通数",
        "unit": "通",
        "targetCount": isDemo ? AchievementPanel.ACHIEVEMENT_DEMO_DATA["LETTER_ORDER_ADDRESS_COUNT"] : (isLoading ? '- ' : addCommas(achievement.letter_order_address_count)),
        // 送付通数のtargetCompanyCountは2023/10/23時点のBDR・SDR統合で表示しないようにしてます。理由は元の作りで存在しなかったためです。
      },
    ];

    menu = menu.concat((hasKLFollowCallBeenEnabled(this.props.user) || isDemo) ?
      [{
        "title": "フォローコール累計",
        "unit": "件",
        "targetCount": isDemo ? AchievementPanel.ACHIEVEMENT_DEMO_DATA["FOLLOW_CALLED_COUNT"] : (isLoading ? '- ' : addCommas(achievement.follow_called_count)),
        "targetCompanyCount": isDemo ? AchievementPanel.ACHIEVEMENT_DEMO_DATA["FOLLOW_CALLED_COMPANY_COUNT"] : (isLoading ? '- ' : addCommas(achievement.follow_called_company_count)),
      }] : []);

    return (
      <div>
        <div className={classes.panel}>
          <PanelHeader
            title={"実績"}
            type={null}
            dateRanges={DateRangesV2}
            dateSelected={this.state.dateSelected}
            handleSelectDate={this.handleSelectDate}
            togglePlanDialog={this.props.togglePlanDialog}
            showUpdateDate={false}
          />

          <div className={classes.flexContainer}>
            {menu.map((item, i) => (
              this.renderItem(item, i, i === (menu.length - 1))
            ))}
          </div>
        </div>
        {this.renderTermRangeDialog()}
      </div>
    )
  }
}

AchievementPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  ownerType: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  achievement: PropTypes.object.isRequired,
  getOrderAchievement: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  user: PropTypes.object,
  isDemo: PropTypes.bool,
};

AchievementPanel.ACHIEVEMENT_DEMO_DATA = {
  "APPROACH_ADDRESS_COUNT": 32,
  "APPROACH_COMPANY_COUNT": 21,
  "LETTER_ORDER_ADDRESS_COUNT": 53,
  "FOLLOW_CALLED_COUNT": 21,
  "FOLLOW_CALLED_COMPANY_COUNT": 10,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isDemo: state.accountSetting.showDemoData,
    isLoading: state.orderList.isLoadingAchievement,
    achievement: state.orderList.achievement,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrderAchievement(data) {
      dispatch(actions.getOrderAchievement(
        {
          ...data,
          targets: [
            "approach_address_count",
            "approach_company_count",
            "follow_called_count",
            "letter_order_address_count",
            "follow_called_company_count",
          ],
        }
      ))
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(AchievementPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/AchievementPanel.jsx